import { createSelector } from 'reselect';
import { find, get } from 'lodash';

import { getScopeFromSettings } from 'containers/pages/Roles/AdvancedRoles/ManageRole/ModelsPermissions/duck/selectors/settings';

export const userLicenses = state => state.licenses.current;
export const corpLicenses = state => state.licenses.list;
const products = state => state.products.list;

const findLicenseById = (licenses, licenseId) =>
  find(licenses, ({ id }) => id === licenseId);

export const corpLicensesAvailableForUser = createSelector(
  userLicenses,
  corpLicenses,
  (userLicenses, corpLicenses) =>
    corpLicenses.filter(
      corpLicense => !findLicenseById(userLicenses, corpLicense.id),
    ),
);

export const getPermissionsViewType = createSelector(
  products,
  getScopeFromSettings,
  (products, scope) => get(find(products, { scope }), 'permissionsViewType'),
);
